module.exports = __webpack_public_path__ + "tab_jindu_selected.png?07c937c007e50ecbfeca8eb057b039d1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tab_jindu_selected.png
// module id = 137
// module chunks = 0